import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'サービス', href: '/services' },
  { label: '料金プラン', href: '/plans' },
  { label: '会社概要', href: '/about' },
  { label: 'お問い合わせ', href: '/contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const handleTopNavigation = (href: string) => {
    if (href === '/') {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }
  };

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white/90 backdrop-blur-md shadow-sm' : 'bg-[#0F172A]/35 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-16 md:h-20">
        {/* Logo */}
        <Link to="/" onClick={() => handleTopNavigation('/')} className="flex items-center gap-2 cursor-pointer">
          <div className="w-8 h-8 flex items-center justify-center">
            <span className="text-2xl">🍑</span>
          </div>
          <span
            className={`font-bold text-lg tracking-wide transition-colors duration-300 ${
              scrolled ? 'text-gray-800' : 'text-white'
            }`}
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            株式会社<span className="text-pink-400">Peach</span>
          </span>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              onClick={() => handleTopNavigation(link.href)}
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer hover:text-pink-400 ${
                scrolled ? 'text-gray-700' : 'text-white/90'
              } ${location.pathname === link.href ? 'text-pink-400' : ''}`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/contact"
            onClick={() => handleTopNavigation('/contact')}
            className="whitespace-nowrap cursor-pointer bg-gradient-to-r from-pink-400 to-pink-500 text-white text-sm font-medium px-5 py-2 rounded-full hover:opacity-90 transition-opacity"
          >
            無料相談
          </Link>
        </nav>

        {/* Mobile Hamburger */}
        <button
          className={`md:hidden w-8 h-8 flex items-center justify-center cursor-pointer ${
            scrolled ? 'text-gray-700' : 'text-white'
          }`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="メニュー"
        >
          <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white/95 backdrop-blur-md border-t border-pink-100 px-6 py-4 flex flex-col gap-4">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              onClick={() => handleTopNavigation(link.href)}
              className="text-gray-700 font-medium text-sm py-2 border-b border-gray-100 cursor-pointer hover:text-pink-400 transition-colors"
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/contact"
            onClick={() => handleTopNavigation('/contact')}
            className="whitespace-nowrap cursor-pointer bg-gradient-to-r from-pink-400 to-pink-500 text-white text-sm font-medium px-5 py-2 rounded-full text-center hover:opacity-90 transition-opacity"
          >
            無料相談
          </Link>
        </div>
      )}
    </header>
  );
}
